import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import axios from 'axios';
import { history } from '../../history';
import { SiteSurveyAction, ErrorCodeAction, ProductAction } from '../../actions';
import { AppHeader } from '../../components/common/LeftMenu';
import { SiteSurveyConstant } from '../../actions/constants/SiteSurveyConstant';
import { useTranslation } from 'react-i18next';
import SurveyStep0 from '../../components/sitesurvey/SurveyStep0';
import SurveyStep1 from '../../components/sitesurvey/SurveyStep1';
import SurveyStep2 from '../../components/sitesurvey/SurveyStep2';
import SurveyStep3 from '../../components/sitesurvey/SurveyStep3';
import SurveyStep4 from '../../components/sitesurvey/SurveyStep4';
import SurveyStep5 from '../../components/sitesurvey/SurveyStep5';
import FilePreviewModal from '../../components/common/FilePreviewModal';
import { Loading } from '../../components/common/Loading';
import { Translate as t } from '../../config/Translate';
import { AppConfig, JWT } from '../../config';
import { resolveFileUrl, downloadWithName } from '../../utils/filePreview';

const SiteSurvey = ({ Get, Update, siteSurvey }) => {

	const dispatch = useDispatch();
	// const [t, i18n] = useTranslation();
	const { _id, view } = useParams();
	const [step, setStep] = useState(1);
	const [gostep, setGoStep] = useState({
		curStep: 100,
		goStepNo: 0
	});
	const [preview, setPreview] = useState({ show: false, file: null, url: '' });
	// 기존 조사서를 읽는 동안 표시 — SiteSurveyReducer.isLoading 은 단계 저장과 공유돼(단계 화면이 언마운트됨) 쓰지 않는다.
	const [fetching, setFetching] = useState(!!_id);
	const aliveRef = useRef(true);

	const apiPost = (body) => axios.post(AppConfig.API_SERVER_PATH + "/file/geturl", body, JWT());

	const handlePreview = async (att) => {
		const url = await resolveFileUrl(att, apiPost);
		if (url) {
			setPreview({ show: true, file: att, url });
		}
	};

	const handleDownload = async (att) => {
		const url = await resolveFileUrl(att, apiPost);
		if (url) {
			await downloadWithName(url, att.name);
		}
	};

	const closePreview = () => {
		setPreview({ show: false, file: null, url: '' });
	};

	useEffect(() => {
		aliveRef.current = true;
		if (_id) {
			// 직전에 본 조사서가 남지 않게 비운 뒤 읽는다(실패해도 이전 조사서가 보이지 않음).
			dispatch({ type: SiteSurveyConstant.GET_SITESURVEY, siteSurvey: {} });
			Promise.resolve(Get(_id)).finally(() => {
				if (aliveRef.current) setFetching(false);
			});
		} else {
			dispatch({ type: SiteSurveyConstant.NEW });
		}
		return () => { aliveRef.current = false; };
	}, [])

	useEffect(() => {
		setStep(siteSurvey.siteSurveyStep);
		setGoStep({
			curStep: 100,
			goStepNo: 0
		});
	}, [siteSurvey])

	// 기존 조사서(_id)를 읽었는데 비어 있으면(조회 실패) 빈 양식을 그리지 않는다. 실패 알림은 액션이 띄운다.
	const loadFailed = !!_id && !fetching && !siteSurvey?._id;

	const getStepTitle = (index) => {
		return index;
	}

	const getHeaderStep = () => {
		const rows = [];
		for (let i = 1; i <= 6; i++) {
			if (step == i) {
				rows.push(<a className="badge badge-primary me-05" href onClick={(e) => goStep(e.target.title, '')} title={i}>{' '}</a>);
			} else {
				rows.push(<a className="badge badge-secondary me-05" href onClick={(e) => goStep(e.target.title, '')} title={i}>{' '}</a>);
			}
		}
		return rows;
	}

	const goStep = (num, addminus) => {
		// ◀▶ 는 현재 단계 기준 한 칸 이동(addminus = -1/1), 배지 클릭은 addminus '' → 해당 단계.
		// 각 Step 컴포넌트가 gostep 을 받아 validate 후 저장한다. 유효 범위 1~6 로 클램프.
		const target = Math.min(6, Math.max(1, Number(num) + (addminus || 0)));
		if (Number.isFinite(target) && target != 6) {
			setGoStep({
				curStep: step,
				goStepNo: target
			});
		}
	}

	return (
		<>
			<div className="appHeader no-border bg-white">
				<div className="left">
					<a href onClick={() => history.goBack()} className="headerButton goBack">
						<ion-icon name="chevron-back-outline" role="img" className="md hydrated" aria-label="chevron back outline"></ion-icon>
					</a>
					<div className="pageTitle">
						{t('installation.label.siteSurvey')}
						{(siteSurvey._id && siteSurvey.siteSitename) && " : " + siteSurvey.siteSitename}
					</div>
				</div>
				<div className="right">
					{/*
					<a href onClick={(e) => setSearchView(!searchView)} className="headerButton">
						<ion-icon name="search-outline"></ion-icon>
					</a>
					*/}
				</div>
			</div>
			<div className="extraHeader full-width step-title">
				{siteSurvey._id && <div className="section-title fl">
					{(view != "view" && step > 1) && <a onClick={() => goStep(step, -1)} className="text-primary btn-sm"><ion-icon name="caret-back-outline" role="img" className="md hydrated" aria-label="caret back outline"></ion-icon></a>}
				</div>}
				<div className="text-center step-badge">
					<h3 style={{ marginBottom: "5px" }}>Step {step}</h3>
					{getHeaderStep()}
				</div>
				{siteSurvey._id && <div className="section-title fr">
					{(view != "view" && step < 6) && <a onClick={step < 5 ? () => goStep(step, 1) : undefined} aria-disabled={step >= 5} className="text-secondary btn-sm" style={step >= 5 ? { opacity: 0.35, cursor: "not-allowed" } : undefined}><ion-icon name="caret-forward-outline" role="img" className="md hydrated" aria-label="caret forward outline"></ion-icon></a>}
				</div>}
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{fetching && <div className="mt-3"><Loading /></div>}
				{!fetching && !loadFailed && view == "view" && <SurveyStep4 info={siteSurvey} view="view" />}
				{!fetching && !loadFailed && view != "view" &&
					<>
						{step === 1 && <SurveyStep0 info={siteSurvey} gostep={gostep.curStep == 1 && gostep} />}
						{step === 2 && <SurveyStep1 info={siteSurvey} gostep={gostep.curStep == 2 && gostep} />}
						{step === 3 && <SurveyStep2 info={siteSurvey} gostep={gostep.curStep == 3 && gostep} />}
						{step === 4 && <SurveyStep3 info={siteSurvey} gostep={gostep.curStep == 4 && gostep} onPreview={handlePreview} onDownload={handleDownload} />}
						{step === 5 && <SurveyStep4 info={siteSurvey} gostep={gostep.curStep == 5 && gostep} />}
						{step === 6 && <SurveyStep5 info={siteSurvey} gostep={gostep.curStep == 6 && gostep} />}
					</>
				}
			</div>

			<FilePreviewModal
				show={preview.show}
				file={preview.file}
				url={preview.url}
				onClose={closePreview}
			/>
		</>
	);
};

const mapState = (state) => {
	const siteSurvey = state.SiteSurveyReducer.siteSurvey;
	return { siteSurvey };
}

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(SiteSurveyAction.UpdateSiteSurvey(_id, data)),
	Create: (data) => dispatch(SiteSurveyAction.CreateSiteSurvey(data)),
	Get: (_id) => dispatch(SiteSurveyAction.GetSiteSurvey(_id)),
});

export default connect(mapState, mapDispatch)(SiteSurvey);
